export default __webpack_public_path__ + "static/media/seller-sales.7948e31f.svg";